import { Line, LineChart, ResponsiveContainer, YAxis } from "recharts";

interface SparklineProps {
  data: { date: string; value: number }[];
  color?: string;
  width?: number;
  height?: number;
}

/** Small inline trend line — no axes, no grid, no tooltip. */
export function Sparkline({
  data,
  color = "var(--amber)",
  width = 110,
  height = 36,
}: SparklineProps) {
  if (!data.length) return null;

  return (
    <div style={{ width, height }} aria-hidden>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 4, right: 2, bottom: 4, left: 2 }}>
          <YAxis hide domain={["dataMin", "dataMax"]} />
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.75}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
